import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import AlertWithUrl from './AlertWithUrl';
import './Table.css';

import { ethers } from 'ethers';

import {
    catastropheBondsFactoryAddress_Fuji,
    catastropheBondsFactoryAddress_Amoy,
    rpcUrl_Amoy,
    rpcUrl_Fuji,
    catastropheBondsCollateralPoolAddress_Fuji,
    catastropheBondsCollateralPoolAddress_Amoy,
    chainSelector_Fuji,
    chainSelector_Amoy,
    usdcTokenAddress_Fuji,
    usdcTokenAddress_Amoy
} from "../config/config.js";

import catastropheBondsFactoryAbi from "../config/abis/catastropheBondsFactory.json";

import catastropheBondAbi from "../config/abis/catastropheBond.json";

import catastropheBondsCollateralPoolAbi from "../config/abis/catastropheBondsCollateralPool.json";

import usdcAbi from "../config/abis/tokens/usdc.json";

const catastropheBondsCollateralPoolContractInterface = ethers.Interface.from(catastropheBondsCollateralPoolAbi);

function Market() {

    const [txSuccess, setTxSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [messageId, setMessageId] = useState('');
    const [nonMintedPositions, setNonMintedPositions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    const [isMinting, setIsMinting] = useState({});
    const [isApproving, setIsApproving] = useState({});


    async function getAllCatastropheBonds() {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let catastropheBondsFactoryContract;

            if (chainId == 43113)
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, provider);
            else if (chainId == 80002)
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, provider);
            else {
                alert("Network not supported")
                return;
            }

            const catastropheBonds = await catastropheBondsFactoryContract.getAllCatastropheBonds();

            return catastropheBonds;
        }
        catch (error) {
            console.error(error.toString())
            alert("Unknown error.");
            return [];
        }
    }

    function formatString(str) {
        return str
            .split('_')                   // Split the string by underscores
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()  // Capitalize each word
            )
            .join(' ');                   // Join the words with spaces
    }

    async function getNonMintedPositionDetailsOfCatastropheBond(catastropheAddress, index) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const catastropheBondContract = new ethers.Contract(catastropheAddress, catastropheBondAbi, provider);

            const isSettled = await catastropheBondContract.isSettled();

            if (!isSettled) {
                const catastropheCode = await catastropheBondContract.getCatastropheCode();
                const location = await catastropheBondContract.getLocation();
                const totalLongTokens = await catastropheBondContract.getTotalLongTokens();
                const totalShortTokens = await catastropheBondContract.getTotalShortTokens();
                const collateralRequiredForMintingAnyPositionToken = await catastropheBondContract.getCollateralRequiredForMintingAnyPositionToken();
                const collateralRequiredForMintingAnyPositionToken_formatted = parseFloat(ethers.formatUnits(collateralRequiredForMintingAnyPositionToken, "mwei"));



                let catastropheEmoji;

                if (catastropheCode == 'wild_fire')
                    catastropheEmoji = '🔥';
                else if (catastropheCode == 'heatwave')
                    catastropheEmoji = '☀️';
                else if (catastropheCode == 'floods')
                    catastropheEmoji = '🌊';
                else if (catastropheCode == 'drought')
                    catastropheEmoji = '🏜️';

                const assetName = `${catastropheEmoji} ${formatString(catastropheCode)} at ${location}`;

                let nonMintedPositions = [];

                if (totalLongTokens == 0) {

                    nonMintedPositions.push({
                        "positionTokenAddress": await catastropheBondContract.getLongPositionToken(),
                        "catastropheAddress": catastropheAddress,
                        "index": index,
                        "asset": assetName,
                        "position": "LONG",
                        "collateralRequiredForMinting": collateralRequiredForMintingAnyPositionToken_formatted,
                    });
                }
                if (totalShortTokens == 0) {

                    nonMintedPositions.push({
                        "positionTokenAddress": await catastropheBondContract.getShortPositionToken(),
                        "catastropheAddress": catastropheAddress,
                        "index": index,
                        "asset": assetName,
                        "position": "SHORT",
                        "collateralRequiredForMinting": collateralRequiredForMintingAnyPositionToken_formatted,
                    });
                }
                return nonMintedPositions;
            }
            return [];

        }
        catch (error) {
            console.error(error.toString())
            console.log("Unknown error.");
            return [];
        }
    }

    let usdcTokenContract;
    async function getUSDCAllowanceForCollateralPool() {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            if (chainId == 43113) {
                usdcTokenContract = new ethers.Contract(usdcTokenAddress_Fuji, usdcAbi, signer);
                const allowance = await usdcTokenContract.allowance(signer.address, catastropheBondsCollateralPoolAddress_Fuji);
                return parseFloat(ethers.formatUnits(allowance, "mwei"));
            }
            else if (chainId == 80002) {
                usdcTokenContract = new ethers.Contract(usdcTokenAddress_Amoy, usdcAbi, signer);
                const allowance = await usdcTokenContract.allowance(signer.address, catastropheBondsCollateralPoolAddress_Amoy);
                console.log(usdcTokenAddress_Amoy, allowance)
                return parseFloat(ethers.formatUnits(allowance, "mwei"));
            }
            else {
                alert("Network not supported")
                return;
            }

        }
        catch (error) {
            console.error(error.toString())
            alert("Unknown error.");
            return;
        }
    }

    async function approveUSDC_ForCollateralPool(amount, positionTokenAddress) {
        try {
            setIsApproving({ [positionTokenAddress]: true });
            const provider = new ethers.BrowserProvider(window.ethereum);

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let catastropheBondsCollateralPoolAddress;
            let networkName;

            if (chainId == 43113) {
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Fuji;
                networkName = "Avalanche Fuji";
            }
            else if (chainId == 80002) {
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Amoy;
                networkName = "Polygon Amoy";
            }
            else {
                alert("Network not supported");
                setIsApproving({ [positionTokenAddress]: false });
                return;
            }

            const amount_formatted = ethers.parseUnits(amount.toString(), "mwei");

            const tx = await usdcTokenContract.approve(catastropheBondsCollateralPoolAddress, amount_formatted);

            const rc = await tx.wait();

            alert(`CatastropheBondsCollateralPool at ${catastropheBondsCollateralPoolAddress} has been approved to spend ${amount} USDC on ${networkName} network.`);

        }
        catch (error) {
            console.error(error.toString())
            alert("Unknown error.");
            setIsApproving({ [positionTokenAddress]: false });
        }
    }

    async function mintLongPositionToken(positionTokenAddress, catastropheAddress, index, collateralRequiredForMinting) {

        let catastropheBondsCollateralPoolAddress;
        try {
            setIsMinting({ [positionTokenAddress]: true });

            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let provider_receiverChain;
            let catastropheBondsCollateralPoolContract;

            let receiverChainDetails;

            if (chainId == 43113) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Amoy);

                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Fuji;

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Fuji, catastropheBondsCollateralPoolAbi, signer);

                const catastropheBondsFactoryContract_Amoy = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Amoy = await catastropheBondsFactoryContract_Amoy.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Amoy,
                    catastropheBond: catastropheAddressAtSameIndex_Amoy,
                    chainSelector: chainSelector_Amoy
                };
            }
            else if (chainId == 80002) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Fuji);

                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Amoy;

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Amoy, catastropheBondsCollateralPoolAbi, signer);

                const catastropheBondsFactoryContract_Fuji = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Fuji = await catastropheBondsFactoryContract_Fuji.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Fuji,
                    catastropheBond: catastropheAddressAtSameIndex_Fuji,
                    chainSelector: chainSelector_Fuji
                };

            }

            else {
                alert("Network not supported");
                setIsMinting({ [positionTokenAddress]: false });
                return;
            }

            const tx = await catastropheBondsCollateralPoolContract.mintLongPositionToken(catastropheAddress, receiverChainDetails);

            const rc = await tx.wait();

            let messageId;
            let mintingMessage;

            rc.logs.forEach(log => {

                const parsedLog = catastropheBondsCollateralPoolContractInterface.parseLog(log);

                if (parsedLog) {
                    if (parsedLog.name == "MessageSent")
                        messageId = parsedLog.args[0];
                    else if (parsedLog.name == "TokensMinted") {
                        mintingMessage = `You've successfully minted ${parseFloat(ethers.formatUnits(parsedLog.args[2]))} Long Position Token (${positionTokenAddress}) of Catastrophe Bond at ${parsedLog.args[0]} to your wallet address at ${parsedLog.args[1]} in exchange of ${parseFloat(ethers.formatUnits(parsedLog.args[3], "mwei"))} USDC.\n\n`
                    }
                }
            });

            if (messageId && mintingMessage) {
                setTxSuccess(true);
                setMessage(mintingMessage);
                setMessageId(messageId);
                setIsMinting({ [positionTokenAddress]: false });
            }

            // alert(`${mintingMessage}\n\nPlease visit https://ccip.chain.link/msg/${messageId} to check the cross-chain minting status of your Long Position Token.`);

        }
        catch (error) {
            setIsMinting({ [positionTokenAddress]: false });
            try {
                const revertData = error.data
                const decodedError = catastropheBondsCollateralPoolContractInterface.parseError(revertData)
                if (decodedError) {
                    if (decodedError.name == 'CatastropheBondsCollateralPool__AllowanceLessThanCollateralNeeded') {
                        alert(`Transaction failed: Please approve the CatastropheBondsCollateralPool contract at ${catastropheBondsCollateralPoolAddress} to spend ${collateralRequiredForMinting} USDC.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__NotFundedWithEnoughLINK") {
                        alert(`Transaction failed: Please fund the CatastropheBondsCollateralPool contract at ${catastropheBondsCollateralPoolAddress} with at least ${parseFloat(ethers.formatUnits(decodedError.args[0]))} LINK token.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__PositionTokenAlreadyMinted") {
                        alert("Transaction failed: Long Position Token is already minted.");
                    }
                    else {
                        console.error(decodedError.name);
                    }

                }
                else {
                    console.error(error.toString());
                    alert("Transaction failed: Unknown error.");
                }
            }
            catch (error) {
                console.log("Error inside the 1st catch...")
                console.error(error.toString());
                alert("Transaction failed: Unknown error.");
            }

        }
    }

    async function mintShortPositionToken(positionTokenAddress, catastropheAddress, index, collateralRequiredForMinting) {

        let catastropheBondsCollateralPoolAddress;
        try {
            setIsMinting({ [positionTokenAddress]: true });

            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let provider_receiverChain;
            let catastropheBondsCollateralPoolContract;

            let receiverChainDetails;

            if (chainId == 43113) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Amoy);

                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Fuji;

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Fuji, catastropheBondsCollateralPoolAbi, signer);

                const catastropheBondsFactoryContract_Amoy = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Amoy = await catastropheBondsFactoryContract_Amoy.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Amoy,
                    catastropheBond: catastropheAddressAtSameIndex_Amoy,
                    chainSelector: chainSelector_Amoy
                };
            }
            else if (chainId == 80002) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Fuji);

                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Amoy;

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Amoy, catastropheBondsCollateralPoolAbi, signer);

                const catastropheBondsFactoryContract_Fuji = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Fuji = await catastropheBondsFactoryContract_Fuji.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Fuji,
                    catastropheBond: catastropheAddressAtSameIndex_Fuji,
                    chainSelector: chainSelector_Fuji
                };

            }

            else {
                alert("Network not supported");
                setIsMinting({ [positionTokenAddress]: false });
                return;
            }

            const tx = await catastropheBondsCollateralPoolContract.mintShortPositionToken(catastropheAddress, receiverChainDetails);

            const rc = await tx.wait();

            let messageId;
            let mintingMessage;

            rc.logs.forEach(log => {

                const parsedLog = catastropheBondsCollateralPoolContractInterface.parseLog(log);

                if (parsedLog) {
                    if (parsedLog.name == "MessageSent")
                        messageId = parsedLog.args[0];
                    else if (parsedLog.name == "TokensMinted") {
                        mintingMessage = `You've successfully minted ${parseFloat(ethers.formatUnits(parsedLog.args[2]))} Short Position Token (${positionTokenAddress}) of Catastrophe Bond at ${parsedLog.args[0]} to your wallet address at ${parsedLog.args[1]} in exchange of ${parseFloat(ethers.formatUnits(parsedLog.args[3], "mwei"))} USDC.\n\n`
                    }
                }
            });
            if (messageId && mintingMessage) {
                setTxSuccess(true);
                setMessage(mintingMessage);
                setMessageId(messageId);
                setIsMinting({ [positionTokenAddress]: false });
            }

            // alert(`${mintingMessage}\n\nPlease visit https://ccip.chain.link/msg/${messageId} to check the cross-chain minting status of your Short Position Token.`);

        }
        catch (error) {
            setIsMinting({ [positionTokenAddress]: false });
            try {
                console.log(error)
                const revertData = error.data
                const decodedError = catastropheBondsCollateralPoolContractInterface.parseError(revertData)
                if (decodedError) {
                    if (decodedError.name == 'CatastropheBondsCollateralPool__AllowanceLessThanCollateralNeeded') {
                        alert(`Transaction failed: Please approve the CatastropheBondsCollateralPool contract at ${catastropheBondsCollateralPoolAddress} to spend ${collateralRequiredForMinting} USDC.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__NotFundedWithEnoughLINK") {
                        alert(`Transaction failed: Please fund the CatastropheBondsCollateralPool contract at ${catastropheBondsCollateralPoolAddress} with at least ${parseFloat(ethers.formatUnits(decodedError.args[0]))} LINK token.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__PositionTokenAlreadyMinted") {
                        alert("Transaction failed: Short Position Token is already minted.");
                    }
                    else {
                        console.error(decodedError.name);
                    }

                }
                else {
                    console.error(error.toString());
                    alert("Transaction failed: Unknown error.");
                }
            }
            catch (error) {
                console.log("Error inside the 1st catch...")
                console.error(error.toString());
                alert("Transaction failed: Unknown error.");
            }
        }
    }

    useEffect(() => {
        const fetchNonMintedPositions = async () => {
            try {
                const catastropheBonds = await getAllCatastropheBonds();
                let nonMintedPositions = [];
                for (var i = 0; i < catastropheBonds.length; i++) {
                    nonMintedPositions.push(...(await getNonMintedPositionDetailsOfCatastropheBond(catastropheBonds[i], i)));
                }

                setNonMintedPositions(nonMintedPositions);
                setIsLoading(false);

            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            }
        };
        fetchNonMintedPositions();
    }, []);

    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const HandleMintClick = async (position, positionTokenAddress, catastropheAddress, index, collateralRequiredForMinting) => {

        console.log('mint clicked for: ', positionTokenAddress)

        const allowance = await getUSDCAllowanceForCollateralPool();

        // console.log(allowance, collateralRequiredForMinting)

        if (allowance < collateralRequiredForMinting) {
            await approveUSDC_ForCollateralPool(collateralRequiredForMinting, positionTokenAddress);
            await sleep(10000);
            setIsApproving({ [positionTokenAddress]: false });
        }

        if (position == "LONG")
            await mintLongPositionToken(positionTokenAddress, catastropheAddress, index, collateralRequiredForMinting);
        else if (position == "SHORT")
            await mintShortPositionToken(positionTokenAddress, catastropheAddress, index, collateralRequiredForMinting);
        else
            alert("Invalid Position");





    };

    return (
        <div>
            {txSuccess && <AlertWithUrl message={message} messageId={messageId} typeOfMessage="minting" target="Position Token" onClose={() => setTxSuccess(false)} />}
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Non-Minted Positions</h4>

                                            <div className="table-responsive">
                                                {isLoading ? (
                                                    <p>Loading...</p>
                                                ) : nonMintedPositions.length ? (
                                                    <table className="table table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th>Asset</th>
                                                                <th>Position</th>
                                                                <th className="two-line-header">Collateral Required <br /> (in USDC)</th>
                                                                <th>Action</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {nonMintedPositions.map((nonMintedPosition) => (
                                                                <tr key={nonMintedPosition.positionTokenAddress}>
                                                                    <td>{nonMintedPosition.asset} </td>
                                                                    <td>{nonMintedPosition.position}</td>
                                                                    <td className="center-align">{nonMintedPosition.collateralRequiredForMinting}
                                                                    </td>
                                                                    <td>
                                                                        {isApproving[nonMintedPosition.positionTokenAddress] ? <p>Approving...</p> : isMinting[nonMintedPosition.positionTokenAddress] ? <p>Minting...</p> : <button className="btn badge-outline-success" onClick={() => HandleMintClick(nonMintedPosition.position, nonMintedPosition.positionTokenAddress, nonMintedPosition.catastropheAddress, nonMintedPosition.index, nonMintedPosition.collateralRequiredForMinting)}>Mint</button>}
                                                                    </td>



                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <p>No market listing available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>
    );
}


export default Market;